// Permissions were required to be sorted in a specific order
/* eslint-disable perfectionist/sort-enums */
export enum AdminConfigPermissions {
  VIEW = 'VIEW_ADMIN_CONFIG',
  WRITE = 'WRITE_ADMIN_CONFIG',
  DELETE = 'DELETE_ADMIN_CONFIG',
}

/** Any one of these opens Admin's General area, and with it the Connected Turnaround chat. */
export const ADMIN_CONFIG_PERMISSIONS = [
  AdminConfigPermissions.VIEW,
  AdminConfigPermissions.WRITE,
  AdminConfigPermissions.DELETE,
];
